import type { FunctionComponent } from "react";

import React from "react";

import { useLanguage } from "../../../../i18n/useLanguage";
import { TireMetatags } from "../../../../queries/useSearchTiresByVehicle";
import { AllWheatherIcon } from "../../../../ui/icons/AllWheatherIcon";
import { EVCarIcon } from "../../../../ui/icons/EVCarIcon";

const textTags = new Set(["studdable", "pre-studded"]);

export const TireMetatagList: FunctionComponent<{
  metatagList: TireMetatags | null;
  tireCategoryTags: string[];
}> = ({ metatagList, tireCategoryTags }) => {
  const [language] = useLanguage();

  if (!metatagList || !tireCategoryTags) {
    return null;
  }

  return (
    <>
      {tireCategoryTags.map(Number).map((tag) => {
        const item = metatagList[tag];

        if (!item) {
          return null;
        }

        const text =
          language === "fr" ? item.tag_text_fr || item.tag_text : item.tag_text;

        switch (tag) {
          case 1:
            return <AllWeather key={tag} text={text} />;
          case 4:
            return <EvTag key={tag} text={text} />;

          default: {
            // NOTE: must compare lowercase english text
            if (textTags.has(item.tag_text.toLowerCase())) {
              return <TextTag key={tag} text={text} />;
            }
            return null;
          }
        }
      })}
    </>
  );
};

const TextTag: FunctionComponent<{ text: string }> = ({ text }) => {
  return (
    <div className="rounded-tw-full p-0.5 bg-input border-edge border px-2 text-xs">
      {text}
    </div>
  );
};

const AllWeather: FunctionComponent<{ text: string }> = ({ text }) => {
  return (
    <div className="rounded-tw-full p-0.5" title={text}>
      <AllWheatherIcon className="h-5 w-5" />
    </div>
  );
};

const EvTag: FunctionComponent<{ text: string }> = ({ text }) => {
  return (
    <div className="bg-green-500 text-white rounded-tw-full p-0.5 px-[0.375em] gap-0.5 inline-flex items-center">
      <EVCarIcon className="h-5 w-5 inline" />
      {text}
    </div>
  );
};
